import React, {useState, useEffect} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

import "./ChangeIdeaFour.css";
import rootCauseIcon from "../../../../../resources/images/root-cause-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import {createChangeIdea} from "../../../../../services/ChangeIdeaService";
import {updateChangeIdea} from "../../../../../services/ChangeIdeaService";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {convertDateToUTC} from "../../../../../util/DateUtil";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";

export const ChangeIdeaFour = ({context, setContext, navigateTo, navigateBack, setSpinnerText, showToaster, toolTipsEnabled}) => {

    const [name, setName] = useState("");
    const [dataSource, setDataSource] = useState("");
    const [processMeasureList, setProcessMeasureList] = useState([]);

    useEffect(() => {
        if (context.changeIdeaScreen) {
            if (context.changeIdeaScreen.processMeasureList) {
                setProcessMeasureList(context.changeIdeaScreen.processMeasureList);
            }
        }
    }, []);

    const handleAddClick = () => {
        const processMeasure = {
            name,
            dataSource,
            type: "",
            value: "",
            visitExternalReference: context.topicAreaScreen.visitExternalReference
        };
        setProcessMeasureList((prevState) => ([...prevState, processMeasure]));
        setName("");
        setDataSource("");
    }

    const handleDeleteClick = (index) => {
        const copyOfProcessMeasureList = [...processMeasureList];
        copyOfProcessMeasureList.splice(index, 1);
        setProcessMeasureList([...copyOfProcessMeasureList]);
    }

    const handleNextClick = async () => {
        let aimStatementVO = null;

        if (context.changeIdeaScreen.to) {
            aimStatementVO = {
                toImprove: context.changeIdeaScreen.toImprove,
                from: context.changeIdeaScreen.from,
                to: context.changeIdeaScreen.to,
                by: convertDateToUTC(context.changeIdeaScreen.byDate),
            }
        }

        const changeIdea = {
            externalReference: context.changeIdeaScreen.externalReference,
            visitExternalReference: context.changeIdeaScreen.visitExternalReference,
            topicAreaExternalReference: context.changeIdeaScreen.topicAreaExternalReference,
            causeExternalReference: context.changeIdeaScreen.causeExternalReference,
            concept: context.changeIdeaScreen.changeConcept,
            priority: context.changeIdeaScreen.priority.label,
            description: context.changeIdeaScreen.description,
            prediction: context.changeIdeaScreen.prediction,
            changeIdeaFileList: context.changeIdeaScreen.changeIdeaFileList,
            processMeasureVOList: processMeasureList,
            title: context.changeIdeaScreen.title,
            aimStatementVO,
        }

        await saveChangeIdea(changeIdea);
    }

    const shouldSkipUpdate = () => {
        const copyOfChangeIdeaScreen = context.copyOfChangeIdeaScreen;
        const currentChangeIdeaScreen = JSON.stringify(context.changeIdeaScreen);

        if (copyOfChangeIdeaScreen !== currentChangeIdeaScreen) {
            return false;
        }

        const contextProcessMeasureList = context.changeIdeaScreen.processMeasureList
        if (contextProcessMeasureList.length !== processMeasureList.length) {
            return false;
        } else {
            for (let i = 0; i < contextProcessMeasureList.length; i++) {
                const contextProcessMeasure = contextProcessMeasureList[i];
                const processMeasure = processMeasureList[i];
                if (contextProcessMeasure.name !== processMeasure.name || contextProcessMeasure.dataSource !== processMeasure.dataSource) {
                    return false;
                }
            }
        }

        return true;
    }

    const saveChangeIdea = async (changeIdea) => {
        setSpinnerText("Saving Change Idea");
        if (!context.changeIdeaScreen.externalReference) {
            const [data, error] = await createChangeIdea(context.username, changeIdea);
            if (data) {
                if (data.responseStatus === "Success") {
                    if (context.viewMode) {
                        setContext((prevState) => ({
                            ...prevState,
                            changeIdeaScreen: {
                                ...prevState.changeIdeaScreen,
                                externalReference: data.createdChangeIdeaVO.externalReference,
                                processMeasureList,
                            }
                        }));
                        navigateTo("changeIdeaOverview");
                    } else {
                        navigateTo("changeIdeaOverview");
                    }
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        } else {
            if (shouldSkipUpdate()) {
                navigateTo("changeIdeaOverview");
            } else {
                changeIdea.changeIdeaFileList = changeIdea.changeIdeaFileList.filter((file) => file.data !== "");
                const [data, error] = await updateChangeIdea(context.username, changeIdea);
                if (data) {
                    if (data.responseStatus === "Success") {
                        if (context.viewMode) {
                            setContext((prevState) => ({
                                ...prevState,
                                changeIdeaScreen: {
                                    ...prevState.changeIdeaScreen,
                                    externalReference: data.updatedChangeIdeaVO.externalReference,
                                    processMeasureList,
                                }
                            }));
                            navigateTo("changeIdeaOverview");
                        } else {
                            navigateTo("changeIdeaOverview");
                        }
                    }
                    showToaster(data);
                } else {
                    showToaster({
                        responseStatus: "Error",
                        responseMessage: error.message,
                    });
                }
            }
        }
        setSpinnerText(null);
    }

    const listItems = processMeasureList.map((processMeasure, index) => {
        return (
            <div className="change-idea-four-process-measure-list-item-container" key={index}>
                <div
                    className={context.editMode ? "change-idea-four-process-measure-list-item-text" : "disabled-change-idea-four-process-measure-list-item-text"}>{processMeasure.name}</div>
                <div
                    className={context.editMode ? "change-idea-four-process-measure-list-item-text" : "disabled-change-idea-four-process-measure-list-item-text"}>{processMeasure.dataSource}</div>
                <div
                    className={context.editMode ? "change-idea-four-process-measure-list-item-delete-button" : "disabled-change-idea-four-process-measure-list-item-delete-button"}
                    onClick={context.editMode ? () => {
                        handleDeleteClick(index)
                    } : null}>
                    <FontAwesomeIcon className="change-idea-four-process-measure-list-item-delete-icon" icon={faTimes}/>
                </div>
            </div>
        );
    });

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={rootCauseIcon} alt="Root Cause Icon" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.rootCauseScreen.name}</p>
                </div>
                <div className="wizard-right-container">
                    <div className="change-idea-four-process-measure-input-container">
                        <div className="change-idea-four-process-measure-input-input-container">
                            <div className={"label-div-tooltip-pm"}>
                                <label className={"label-pm"}>Process Measure:</label>
                                {toolTipsEnabled &&
                                <ToolTip tooltipExternalReference={"processmmeasure123"}
                                         context={context}
                                         setSpinnerText={setSpinnerText} showToaster={showToaster}
                                         fieldName={"Process Measure:"}/>}
                            </div>
                            <input onChange={({target}) => {
                                setName(target.value)
                            }}
                                   value={name}
                                   disabled={!context.editMode}/>
                        </div>
                        <div className="change-idea-four-process-measure-input-input-container">
                            <div className={"label-div-tooltip-pm"}>
                                <label className={"label-pm"}>Data Source:</label>
                                {toolTipsEnabled &&
                                <ToolTip tooltipExternalReference={"datassource123"}
                                         context={context}
                                         setSpinnerText={setSpinnerText} showToaster={showToaster}
                                         fieldName={"Data Source:"}/>}
                            </div>
                            <input onChange={({target}) => {
                                setDataSource(target.value)
                            }}
                                   value={dataSource}
                                   disabled={!context.editMode}/>
                        </div>
                        <button className={"change-idea-four-process-measure-input-container-add-button"}
                                onClick={handleAddClick} disabled={name === "" || dataSource === ""}>Add
                        </button>
                    </div>
                    {listItems}
                    {context.viewMode && context.changeIdeaScreen && context.changeIdeaScreen.externalReference &&
                    <CommentToolTip contextName={"Cause"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.changeIdeaScreen.externalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={processMeasureList.length === 0} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
